




























import Vue from 'vue'
import Component from 'vue-class-component'
import { State, Action, Mutation } from 'vuex-class'
import { Product } from '@/modules/product'
import FileButton from '@/components/FileButton.vue'

/**
 * Muestra la imagen del producto
 *
 * @author Alejandro G. Riaño <agutierrez@softcontro.es>
 */
@Component({
    components: {
        'file-button': FileButton,
    },
})
export default class ProductImage extends Vue {

    public base64data = ''
    public uploading = false

    @State(state => state.product.showProductImage)
    public visible: boolean

    /**
     * Producto actualmente en edición
     */
    @State(state => state.product.currentProduct)
    public product: Product

    @Mutation('product/product/image/show')
    public showProductImage: (show: boolean) => void

    @Action('product/loadLargeImage')
    public loadImage: () => void

    @Action('product/uploadProductImage')
    public uploadImage: (file: string) => void

    public onFile (file: File) {
        const reader = new FileReader()

        reader.addEventListener('loadend', (event) => {
            this.base64data = reader.result as string
        })

        reader.readAsDataURL(file)
    }

    public async upload () {
        this.uploading = true
        await this.uploadImage(this.base64data)

        this.uploading = false
        this.base64data = ''
    }

    public async created () {
        this.loadImage()
    }
}
